<template>
    <v-container fill-height class="grey lighten-5">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="8" lg="6">
          
          <v-card class="rounded-xl pa-8 text-center elevation-12 overflow-hidden border-premium">
            <!-- Decoración de fondo sutil -->
            <div class="premium-bg-gradient"></div>
  
            <!-- Icono con animación -->
            <div class="mb-6">
              <div class="icon-pulse">
                <v-icon size="100" color="amber darken-3">mdi-shield-lock-outline</v-icon>
              </div>
            </div>
  
            <!-- Texto de Marketing -->
            <h2 class="text-h4 font-weight-black grey--text text--darken-3 mb-4">
              Área de Acceso Exclusivo
            </h2>
            
            <p class="text-subtitle-1 grey--text text--darken-1 mb-8">
              Has intentado acceder a una sección de <strong>Alto Nivel</strong>. Esta funcionalidad está reservada para usuarios con permisos avanzados o licencias específicas de gestión.
            </p>
  
            <!-- Beneficios (FOMO: Fear of Missing Out) -->
            <v-card flat color="amber lighten-5" class="rounded-lg pa-6 mb-8 text-left border-amber">
              <div class="text-overline mb-2 amber--text text--darken-4 font-weight-bold">
                ¿Qué beneficios incluye?
              </div>
              <v-row dense>
                <v-col cols="12" sm="6" v-for="(item, i) in benefits" :key="i" class="d-flex align-center">
                  <v-icon small color="amber darken-3" class="mr-2">mdi-check-decagram</v-icon>
                  <span class="text-body-2 grey--text text--darken-2">{{ item }}</span>
                </v-col>
              </v-row>
            </v-card>
  
            <!-- Acciones -->
            <!-- <div class="d-flex flex-column flex-sm-row justify-center gap-4">
              <v-btn
                color="grey darken-3"
                dark
                outlined
                large
                class="rounded-lg px-8 text-none font-weight-bold"
                @click="$router.push('/')"
              >
                <v-icon left>mdi-arrow-left</v-icon>
                Volver al inicio
              </v-btn>
  
              <v-btn
                color="amber darken-3"
                dark
                large
                depressed
                class="rounded-lg px-8 text-none font-weight-bold shadow-premium"
                @click="solicitarAcceso"
              >
                <v-icon left>mdi-rocket-launch</v-icon>
                Solicitar Acceso PRO
              </v-btn>
            </div> -->
  
            <!-- Enlace de soporte -->
            <div class="mt-8">
              <a href="#" class="text-caption grey--text text-decoration-none">
                ¿Crees que esto es un error? Contacta con tu administrador
              </a>
            </div>
          </v-card>
  
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    name: 'NoAccessView',
    data() {
      return {
        benefits: [
          'Firma y descarga de partes',
          'Gestión de armarios y planos',
          'Tienda online Ramos',
          'Mantenimientos preventivos',
          'Inventario de artículos',
        ]
      }
    },
    methods: {
      solicitarAcceso() {
        // Aquí podrías abrir un chat, enviar un mail o registrar un lead
        console.log("Lead registrado para upgrade");
        alert("¡Gracias! Tu solicitud ha sido enviada al administrador del sistema.");
      }
    }
  }
  </script>
  
  <style scoped>
  /* Bordes y sombras especiales para el look "Premium" */
  .border-premium {
    border: 1px solid rgba(255, 179, 0, 0.3) !important;
  }
  
  .border-amber {
    border: 1px solid #ffb300 !important;
  }
  
  .shadow-premium {
    box-shadow: 0 4px 15px rgba(255, 179, 0, 0.4) !important;
  }
  
  /* Animación de pulso para el candado */
  .icon-pulse {
    animation: pulse-animation 2s infinite;
    display: inline-block;
  }
  
  @keyframes pulse-animation {
    0% { transform: scale(1); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
  }
  
  /* Gradiente de fondo muy sutil en la esquina de la tarjeta */
  .premium-bg-gradient {
    position: absolute;
    top: -50px;
    right: -50px;
    width: 150px;
    height: 150px;
    background: radial-gradient(circle, rgba(255,179,0,0.1) 0%, rgba(255,255,255,0) 70%);
    pointer-events: none;
  }
  
  .gap-4 {
    gap: 16px;
  }
  
  /* Estilo para pantallas móviles */
  @media (max-width: 600px) {
    .gap-4 {
      flex-direction: column;
    }
  }
  </style>